import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';

// import Chats from './apps/chats/Chats';
// import Email from './apps/email/Email';
// import Todo from './apps/todo/Todo';

import Alerts from './components/alerts/Alerts';
import Accordions from './components/accordion/Accordions';
import Badge from './components/badge/Badge';
import Button from './components/button/Button';
import Chart from './components/chart/Chart';
import Forms from './components/forms/Forms';
import Modal from './components/modal/Modal';
import ListGroup from './components/listgroup/ListGroup';
import Progress from './components/progress/Progress';
import Tabs from './components/tabs/Tabs';
import Tables from './components/table/Tables';

import Main from './layout/Main';

import Auth from './container/Auth';
import Admin from './container/Admin';

import Login from './auth/Login';
import Register from './auth/Register';

import User from './user/User';

import { keepTheme } from './utils/themes';

export default function App() {
    useEffect(() => {
        keepTheme();
    });

    return (
        <>
            <Switch>
                <Route path={['/auth']}>
                    <Auth>
                        <Switch>
                            <Route path='/auth/login' component={Login} />

                            <Route path='/auth/register' component={Register} />
                        </Switch>
                    </Auth>
                </Route>

                <Route path={['/']}>
                    <Admin>
                        <Switch>
                            <Route path='/alerts' component={Alerts} />
                            <Route path='/accordions' component={Accordions} />
                            <Route path='/badge' component={Badge} />
                            <Route path='/button' component={Button} />
                            <Route path='/chart' component={Chart} />
                            <Route path='/forms' component={Forms} />
                            <Route path='/modal' component={Modal} />
                            <Route path='/listgroup' component={ListGroup} />
                            <Route path='/progress' component={Progress} />
                            <Route path='/tabs' component={Tabs} />
                            <Route path='/tables' component={Tables} />
                            <Route path='/user' component={User} />
                            <Route exact path='/' component={Main} />
                        </Switch>
                    </Admin>
                </Route>
            </Switch>
        </>
    );
}
